import { FC } from 'react';
import { Link } from "react-router-dom";
import Banners  from "../../containers/banner";
import './policy.scss';

interface PageProps {
    title: string;
}

const Term:FC<PageProps> = ({title}) => {
    return (
        <div className="">
            <Banners title={title} />
            <div className='row'>
                <div className="container">
                    <div className="cont-agg-all">
                        <section>
                            <h3>제1조 목적</h3>
                            <div className="agg-item_text">
                                본 약관은 맵프라임 서비스 운영기관(이하 ‘운영기관’이라 한다)에서 운영하는 공공SaaS 서비스를 이용함에 있어 이용조건 및 절차, 운영기관과 이용자의 권리·의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
                            </div>
                        </section>

                        <section>
                            <h3>제2조 용어의 정의</h3>
                            <div className="agg-item_text">
                                본 약관에서 사용하는 용어의 정의는 다음과 같습니다. 본 약관에서 정의하지 않은 것은 관련 법령 및 서비스별 안내에서 정하는 바에 따르며, 그 외에는 일반 관례에 따른다.
                            </div>
                            <ul className="agg-item_list2">
                                <li data-no="①">공유서비스 : 공유서비스란 인공지능 서비스에 활용할 수 있는 데이터, SW, 컴퓨팅 자원 등 우수한 정보자원을 공공 및 민간, 법인 및 개인이 원활하게 활용할 수 있도록 다양한 형식과 방식으로 제공하는 것을 말한다.</li>
                                <li data-no="②">제공기관 : 제공기관은 기관이 보유하고 있는 우수한 정보자원을 지정된 관리시스템을 통해 활용 가능한 공유서비스의 방식으로 개방, 제공하는 행정기관, 공공기관 및 민간 개인과 법인 등을 말한다.</li>
                                <li data-no="③">활용기관 : 활용기관은 제공된 공유서비스를 직접 이용하거나 새로운 창작물의 일부로 재가공하여 배포하는 행정기관 등과 개인 및 법인을 말한다.</li>
                                <li data-no="④">행정기관 등 : 행정기관 및 공공기관을 행정기관 등 이라 말한다.</li>
                                <li data-no="⑤">회원 : 공공SaaS에 기관 및 기업, 개인 정보를 제공하여 제공기관 또는 활용기관으로 등록한 자로서 공공SaaS에서 제공하는 서비스를 이용할 수 있는 자.</li>
                                <li data-no="⑥">비밀번호 : 이용자와 회원ID가 일치하는지 확인하고 통신상의 자신의 비밀 보호를 위하여 이용자 자신이 선정한 문자와 숫자의 조합.</li>
                            </ul>
                        </section>

                        <section>
                            <h3>제3조 약관의 효력과 변경</h3>
                            <ul className="agg-item_list1">
                                <li data-no="1">공공SaaS는 귀하가 본 약관 내용에 동의하는 경우, 공공SaaS의 서비스 제공 행위 및 귀하의 서비스 사용 행위에 본 약관이 우선적으로 적용됩니다.</li>
                                <li data-no="2">
                                    운영기관은 본 약관을 약관법 등 관련 법령에 위배되지 않는 범위 안에서 사전 고지 없이 변경할 수 있고, 변경된 약관은 공공SaaS 내에 공지와 동시에 그 효력이 발생됩니다.<br />
                                    회원이 변경된 약관에 동의하지 않는 경우, 회원은 본인의 회원등록을 취소(회원탈퇴)할 수 있으며 계속 사용하는 경우는 약관 변경에 대한 동의로 간주됩니다.
                                </li>
                            </ul>
                        </section>

                        <section>
                            <h3>제4조 약관 외 준칙</h3>
                            <div className="agg-item_text">본 약관에 명시되지 않은 사항은 전기통신기본법, 전기통신사업법, 정보통신에 관한 심의규정, 저작권법 및 기타 관련 법령의 규정에 의합니다.</div>
                        </section>

                        <section>
                            <h3>제5조 이용 계약의 성립 등</h3>
                            <ul className="agg-item_list1">
                                <li data-no="1">이용 계약은 법인 및 개인 신청자가 온라인으로 공공SaaS에서 제공하는 소정의 회원가입 신청 양식에서 요구하는 사항을 기록하여 가입을 완료하는 것으로 성립됩니다.</li>
                                <li data-no="2">행정기관 등은 법인 회원으로 가입한 이후에 공유서비스 제공기관으로 전환가입이 가능하며, 제공가입 후에는 공유서비스를 등록할 수 있는 자격이 부여됩니다.</li>
                                <li data-no="3">
                                    공공SaaS는 다음 각 호에 해당하는 이용계약에 대하여는 회원 가입을 취소할 수 있습니다.
                                    <ul className="agg-item_list2">
                                        <li data-no="①">다른 사람의 명의를 사용하여 신청하였을 때</li>
                                        <li data-no="②">회원 가입 신청서의 내용을 허위로 기재하였을 경우</li>
                                        <li data-no="③">공공SaaS을 이용하여 법령과 본 약관이 금지하는 행위를 하는 경우</li>
                                        <li data-no="④">기타 운영기관에서 정한 제공기관 및 활용기관에 대한 공유정책 및 업무처리 기준에 위배된 경우</li>
                                    </ul>
                                </li>
                            </ul>
                        </section>

                        <section>
                            <h3>제6조 회원 정보 사용에 대한 동의</h3>
                            <ul className="agg-item_list1">
                                <li data-no="1">회원의 개인정보는 개인정보법에 의해 보호됩니다.</li>
                                <li data-no="2">
                                    공공SaaS의 회원정보는 다음과 같이 사용, 관리, 보호됩니다.
                                    <ul className="agg-item_list2">
                                        <li data-no="①">개인정보의 사용 : 공공SaaS는 서비스 제공과 관련해서 수집된 회원의 신상정보를 본인의 승낙없이 제3자에게 누설, 배포하지 않습니다. 단, 전기통신기본법 등 법률의 규정에 의해 국가기관의 요구가 있는 경우,
                                            범죄에 대한 수사상의 목적이 있거나 방송통신심의위원회의 요청이 있는 경우 또는 기타 관계법령에서 정한 절차에 따른 요청이 있는 경우, 귀하가 공공SaaS에 제공한 개인정보를 스스로 공개한 경우에는 그러하지 않습니다.
                                        </li>
                                        <li data-no="②">개인정보의 관리 : 귀하는 개인정보의 보호 및 관리를 위하여 서비스의 개인정보관리에서 수시로 귀하의 개인정보를 수정/삭제할 수 있습니다.</li>
                                        <li data-no="③">개인정보의 보호 : 귀하의 개인정보는 오직 귀하만이 열람/수정/삭제 할 수 있으며, 이는 전적으로 귀하의 ID와 비밀번호에 의해 관리되고 있습니다. 따라서 타인에게 본인의 ID와 비밀번호를 알려주어서는 안되며, 작업 종료시에는 반드시 로그아웃 해 주시기 바랍니다.</li>
                                    </ul>
                                </li>
                                <li data-no="3">회원이 본 약관에 따라 이용신청을 하는 것은 공공SaaS 회원가입 신청서에 기재된 회원정보를 ‘개인정보 취급방침’에 따라 수집, 이용하는 것에 동의하는 것으로 간주됩니다.</li>
                            </ul>
                        </section>

                        <section>
                            <h3>제7조 사용자의 정보 보안</h3>
                            <ul className="agg-item_list1">
                                <li data-no="1">가입 신청자가 공공SaaS 회원가입 절차를 완료하는 순간부터 회원은 입력한 정보의 비밀을 유지할 책임이 있으며, 회원의 ID와 비밀번호를 사용하여 발생하는 모든 결과에 대한 책임은 회원 본인에게 있습니다.</li>
                                <li data-no="2">
                                    ID와 비밀번호에 관한 모든 관리의 책임은 회원에게 있으며, 회원의 ID나 비밀번호가 부정하게 사용 되었다는 사실을 발견한 경우에는 즉시 운영기관에 신고하여야 합니다. <br />
                                    신고를 하지 않음으로 인한 모든 책임은 회원 본인에게 있습니다.
                                </li>
                                <li data-no="3">
                                    회원은 공공SaaS 사용 종료 시마다 정확히 접속을 종료해야 하며, 정확히 종료하지 아니함으로써 제3자가 귀하에 관한 정보를 이용하게 되는 등의 결과로 인해 발생하는 손해 및 손실에 대하여 <br />
                                    운영기관은 책임을 부담하지 아니합니다
                                </li>
                            </ul>
                        </section>

                        <section>
                            <h3>제8조 포털 이용 시간</h3>
                            <ul className="agg-item_list1">
                                <li data-no="1">당 사이트는 제6조의 규정에 의한 이용신청고객에 대하여 서비스 이용을 승낙합니다.
                                </li>
                                <li data-no="2">
                                    당 사이트는 아래사항에 해당하는 경우에 대해서 승낙하지 아니 합니다.
                                    <ul className="agg-item_list2">
                                        <li data-no="①">이용계약 신청서의 내용을 허위로 기재한 경우</li>
                                        <li data-no="②">기타 규정한 제반사항을 위반하며 신청하는 경우</li>
                                    </ul>
                                </li>
                            </ul>
                        </section>

                        <section>
                            <h3>제9조 포털의 중지 및 정보의 저장과 사용</h3>
                            <ul className="agg-item_list1">
                                <li data-no="1">공공SaaS에 보관되거나 전송된 메시지 및 기타 통신 메시지 등의 내용이 국가의 비상사태, 정전, 공공SaaS의 관리 범위 외의 서비스 설비 장애 및 기타 불가항력에 의하여 보관되지 못하였거나 삭제된 경우, 전송되지 못한 경우 및 기타 통신 데이터의 손실이 있을 경우에 운영기관은 관련 책임을 부담하지 아니합니다.</li>
                                <li data-no="2">
                                    공공SaaS의 정상적인 서비스 제공이 불가하여 일시적으로 서비스를 중지하여야 할 경우에는 서비스 중지 1주일 전의 고지 후 서비스를 중지할 수 있으며, 이 기간 동안 귀하가 고지내용을 인지하지
                                    못한 데 대하여 운영기관은 책임을 부담하지 아니합니다. 부득이한 사정이 있을 경우 위 사전 고지기간은 감축되거나 생략될 수 있습니다. 또한 위 서비스 중지에 의하여 본 서비스에 보관되거나
                                    전송된 메시지 및 기타 통신 메시지 등의 내용이 보관되지 못하였거나 삭제된 경우, 전송되지 못한 경우 및 기타 통신 데이터의 손실이 있을 경우에 대하여도 운영기관은 책임을 부담하지 아니합니다.
                                </li>
                                <li data-no="3">공공SaaS의 사정으로 서비스를 영구적으로 중단하여야 할 경우 제 2 항에 의거합니다. 다만, 이 경우 사전 고지기간은 1개월로 합니다.</li>
                                <li data-no="4">공공SaaS는 사전 고지 후 서비스를 일시적으로 수정, 변경 및 중단할 수 있으며, 이에 대하여 귀하 또는 제3자에게 어떠한 책임도 부담하지 아니합니다.</li>
                                <li data-no="5">공공SaaS는 이용자가 본 약관의 내용에 위배되는 행동을 한 경우, 임의적인 회원의 서비스 이용 중지시(회원등록 말소시) 회원에게 이 사실을 통지하고, 회원으로 하여금 소명할 수 있는 기회를 부여하고 소명기간(30일 이상)을 추가 표기합니다.</li>
                            </ul>
                        </section>

                        <section>
                            <h3>제10조 서비스의 변경 및 해지</h3>
                            <ul className="agg-item_list1">
                                <li data-no="1">공공SaaS는 회원이 서비스를 이용하여 기대하는 손익이나 서비스를 통하여 얻은 자료로 인한 손해에 관하여 책임을 지지 않으며, 회원이 본 서비스에 게재한 정보, 자료, 사실의 신뢰도, 정확성 등
                                    내용에 관하여는 책임을 지지 않습니다.</li>
                                <li data-no="2">공공SaaS는 서비스 이용과 관련하여 회원에게 발생한 손해 중 회원의 고의, 과실에 의한 손해에 대하여 책임을 부담하지 아니합니다.</li>
                            </ul>
                        </section>

                        <section>
                            <h3>제11조 정보 제공 및 홍보물 게재</h3>
                            <ul className="agg-item_list1">
                                <li data-no="1">공공SaaS는 서비스를 운영함에 있어서 각종 정보를 서비스에 게재하는 방법 등으로 회원에게 제공할 수 있습니다.</li>
                                <li data-no="2">공공SaaS는 서비스에 적절하다고 판단되거나 활용 가능성 있는 홍보물을 게재할 수 있습니다.</li>
                            </ul>
                        </section>

                        <section>
                            <h3>제12조 게시물의 저작권</h3>
                            <ul className="agg-item_list1">
                                <li data-no="1">제공기관이 게시한 게시물의 내용에 대한 권리는 기본적으로 제공기관 본인에게 있습니다.</li>
                                <li data-no="2">
                                    공공SaaS는 게시된 내용을 사전 통지 없이 편집, 이동할 수 있는 권리를 보유하며, 다음의 경우 사전 통지 없이 삭제할 수 있습니다.
                                    <ul className="agg-item_list2">
                                        <li data-no="①">본 서비스 약관에 위배되거나 상용 또는 불법, 음란, 저속하다고 판단되는 게시물을 게시한 경우</li>
                                        <li data-no="②">다른 회원 또는 제 3자를 비방하거나 중상모략으로 명예를 손상시키는 내용인 경우</li>
                                        <li data-no="③">공공질서 및 미풍양속에 위반되는 내용인 경우</li>
                                        <li data-no="④">범죄적 행위에 결부된다고 인정되는 내용일 경우</li>
                                        <li data-no="⑤">제3자의 저작권 등 기타 권리를 침해하는 내용인 경우</li>
                                        <li data-no="⑥">기타 관계 법령에 위배되는 경우</li>
                                    </ul>
                                </li>
                                <li data-no="3">제공기관의 게시물이 타인의 저작권을 비롯한 기타 타인의 권리를 침해함으로써 발생하는 민, 형사상의 책임은 전적으로 제공기관이 부담하여야 합니다.</li>
                            </ul>
                        </section>

                        <section>
                            <h3>제13조 사용자의 행동 규범 및 서비스의 이용 제한</h3>
                            <ul className="agg-item_list1">
                                <li data-no="1">회원이 제공하는 정보의 내용이 허위인 것으로 판명되거나, 그러하다고 의심할 만한 합리적인 사유가 발생할 경우 공공SaaS는 회원의 본 서비스 사용을 일부 또는 전부 중지할 수 있으며, 이로 인해 발생하는 불이익에 대해 책임을 부담하지 아니합니다.</li>
                                <li data-no="2">회원이 공공SaaS의 서비스를 통해 게시, 전송, 입수하였거나 전자메일 기타 다른 수단에 의하여 게시, 전송 또는 입수한 모든 형태의 정보에 대하여는 회원이 모든 책임을 부담하며 공공SaaS는 어떠한 책임도 부담하지 아니합니다.</li>
                                <li data-no="3">공공SaaS는 당 사이트가 제공한 서비스가 아닌 가입자 또는 기타 유관기관이 제공하는 서비스의 내용상의 정확성, 완전성 및 질에 대하여 보장하지 않습니다. 따라서 공공SaaS는 회원이 위 내용을 이용함으로 인하여 입게 된 모든 종류의 손실이나 손해에 대하여 책임을 부담하지 아니합니다.</li>
                                <li data-no="4">회원은 공공SaaS에서 다운로드 받은 데이터 내에 개인정보 또는 개인정보로 우려되는 정보가 포함된 것을 발견한 경우 즉시 공공SaaS 운영자에 신고하고 해당 데이터셋은 삭제를 하여야 합니다.</li>
                                <li data-no="5">회원은 공공SaaS로부터 제공받은 비식별 정보를 인공지능 서비스 개발 등의 목적으로 안전하게 이용하여야 하며, 이를 이용해서 개인을 재식별하기 위한 어떠한 행위도 하여서는 안됩니다.</li>
                                <li data-no="6">
                                    회원은 본 서비스를 통하여 다음과 같은 행동을 포함하여 서비스 운영정책에서 금지하는 행위를 하지 않는 것에 동의합니다.
                                    <ul className="agg-item_list2">
                                        <li data-no="①">타인의 아이디(ID)와 비밀번호를 도용하는 행위</li>
                                        <li data-no="②">저속, 음란, 모욕적, 위협적이거나 타인의 프라이버시를 침해할 수 있는 내용을 전송, 게시, 게재, 전자메일 또는 기타의 방법으로 전송하는 행위</li>
                                        <li data-no="③">서비스를 통하여 전송된 내용의 출처를 위장하는 행위</li>
                                        <li data-no="④">법률, 계약에 의하여 이용할 수 없는 내용을 게시, 게재, 전자메일 또는 기타의 방법으로 전송하는 행위</li>
                                        <li data-no="⑤">타인의 특허, 상표, 영업비밀, 저작권, 기타 지식재산권을 침해하는 내용을 게시, 게재, 전자메일 또는 기타의 방법으로 전송하는 행위</li>
                                        <li data-no="⑥">운영기관의 승인을 받지 아니한 광고, 판촉물, 정크메일, 스팸, 행운의 편지, 피라미드 조직 기타 다른 형태의 권유를 게시, 게재, 전자메일 또는 기타의 방법으로 전송하는 행위</li>
                                        <li data-no="⑦">다른 사용자의 개인정보를 수집 또는 저장하는 행위</li>
                                        <li data-no="⑧">다른 사용자의 공공SaaS 서비스 이용을 방해하는 행위</li>
                                        <li data-no="⑨">의도적으로 바이러스 프로그램 등 파괴적이거나 시스템에 손상을 줄 수 있는 아이템을 배포하는 행위</li>
                                    </ul>
                                </li>
                                <li data-no="7">공공SaaS는 회원이 본 약관을 위배했다고 판단되면 서비스와 관련된 모든 정보를 회원의 동의 없이 삭제할 수 있습니다.</li>
                            </ul>
                        </section>

                        <section>
                            <h3>제14조 포털의 의무</h3>
                            <ul className="agg-item_list1">
                                <li data-no="1">공공SaaS는 법령과 본 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 지속적, 안정적으로 서비스를 제공하기 위해 노력할 의무가 있습니다.</li>
                                <li data-no="2">공공SaaS는 회원의 개인 신상 정보를 본인의 승낙 없이 타인에게 누설, 배포하지 않습니다. 다만, 전기통신관련법령 등 관계법령에 의하여 관계 국가기관 등의 요구가 있는 경우에는 그러하지 아니합니다.</li>
                                <li data-no="3">공공SaaS는 이용자가 안전하게 당 사이트 서비스를 이용할 수 있도록 이용자의 개인정보(신용정보 포함) 보호를 위한 보안시스템을 갖추어야 합니다.</li>
                                <li data-no="4">공공SaaS는 이용자의 귀책사유로 인한 서비스 이용 장애에 대하여 책임을 지지 않습니다.</li>
                            </ul>
                        </section>

                        <section>
                            <h3>제15조 회원의 의무</h3>
                            <ul className="agg-item_list1">
                                <li data-no="1">회원 가입시에 요구되는 정보는 정확하게 기입하여야 합니다. 또한 이미 제공된 회원 정보가 정확한 정보가 되도록 유지, 갱신하여야 하며, 회원은 자신의 ID 및 비밀번호를 제3자에게 이용하게 해서는 안됩니다.</li>
                                <li data-no="2">회원은 공공SaaS의 사전 승낙 없이 서비스를 이용하여 어떠한 영리행위도 할 수 없습니다.</li>
                                <li data-no="3">회원은 일부 개인정보를 포함한 서비스 중 사전 승낙이 필요함을 별도로 명시한 경우 사전 승낙 없이 공공SaaS의 서비스를 이용하여 얻은 정보를 복사, 복제, 변경, 번역, 출판·방송 기타의 방법으로 사용하거나 이를 타인에게 제공할 수 없습니다.</li>
                                <li data-no="4">
                                    회원은 공공SaaS의 서비스 이용과 관련하여 다음 각 호의 행위를 하여서는 안됩니다.
                                    <ul className="agg-item_list2">
                                        <li data-no="①">다른 회원의 ID를 부정 사용하는 행위</li>
                                        <li data-no="②">범죄행위를 목적으로 하거나 기타 범죄행위와 관련된 행위</li>
                                        <li data-no="③">선량한 풍속, 기타 사회질서를 해하는 행위</li>
                                        <li data-no="④">타인의 명예를 훼손하거나 모욕하는 행위</li>
                                        <li data-no="⑤">타인의 지식재산권 등의 권리를 침해하는 행위</li>
                                        <li data-no="⑥">해킹행위 또는 컴퓨터바이러스의 유포행위</li>
                                        <li data-no="⑦">타인의 의사에 반하여 광고성 정보 등 일정한 내용을 지속적으로 전송하는 행위</li>
                                        <li data-no="⑧">서비스의 안전적인 운영에 지장을 주거나 줄 우려가 있는 일체의 행위</li>
                                        <li data-no="⑨">공공SaaS에 게시된 정보의 변경</li>
                                    </ul>
                                </li>
                            </ul>
                        </section>

                        <section>
                            <h3>제16조 포털의 소유권</h3>
                            <ul className="agg-item_list1">
                                <li data-no="1">공공SaaS가 제공하는 서비스, 그에 필요한 소프트웨어, 이미지, 마크, 로고, 디자인, 서비스명칭, 정보 및 상표 등과 관련된 지식재산권 및 기타 권리는 운영기관(및 공공SaaS 서비스 제공과 관련하여 운영기관과 계약을 체결한 기관)에 소유권이 있습니다.</li>
                                <li data-no="2">귀하는 공공SaaS에서 명시적으로 승인한 경우를 제외하고는 전항의 소정의 각 재산에 대한 전부 또는 일부의 수정, 대여, 대출, 판매, 배포, 제작, 양도, 재라이센스, 담보권 설정 행위, 상업적 이용 행위를 할 수 없으며, 제3자로 하여금 이와 같은 행위를 하도록 허락할 수 없습니다.</li>
                            </ul>
                        </section>

                        <section>
                            <h3>제17조 양도 금지</h3>
                            <div className="agg-item_text">회원이 서비스의 이용권한, 기타 이용계약 상 지위를 타인에게 양도, 증여할 수 없으며, 이를 담보로 제공할 수 없습니다. 단, 법인회원의 대표담당자 변경은 예외로 합니다.</div>
                        </section>

                        <section>
                            <h3>제18조 손해 조항</h3>
                            <div className="agg-item_text"> 공공SaaS는 무료로 제공되는 서비스와 관련하여 회원에게 어떠한 손해가 발생하더라도 공공SaaS가 고의로 행한 범죄행위를 제외하고 이에 대하여 책임을 부담하지 아니합니다.</div>
                        </section>

                        <section>
                            <h3>제19조 면책 조항</h3>
                            <ul className="agg-item_list1">
                                <li data-no="1">공공SaaS는 서비스에 표출된 어떠한 의견이나 정보에 대해 확신이나 대표할 의무가 없으며 회원이나 제3자에 의해 표출된 의견을 승인하거나 반대하거나 수정하지 않습니다. 공공SaaS는 어떠한 경우라도 회원이 서비스에 담긴 정보에 의존해 얻은 이득이나 입은 손해에 대해 책임이 없습니다.</li>
                                <li data-no="2">공공SaaS는 회원 간 또는 회원과 제3자 간에 서비스를 매개로 하여 물품거래 혹은 금전적 거래 등과 관련하여 어떠한 책임도 부담하지 아니하고, 회원이 서비스의 이용과 관련하여 기대하는 이익에 관하여 책임을 부담하지 않습니다.</li>
                            </ul>

                        </section>
                        <section>
                            <h3>제20조 관할 법원</h3>
                            <div className="agg-item_text">본 서비스 이용과 관련하여 발생한 분쟁에 대해 소송이 제기될 경우 서울중앙지방법원을 전속적 관할 법원으로 합니다.</div>
                            <ul className="agg-item_list2">
                                <li data-no="①">(시행일) 본 약관은 2025년 1월 1일부터 시행됩니다.</li>
                            </ul>
                        </section>

                        <section>
                            <h3>(심메타 클라우드 서비스 이용약관)</h3>
                        </section>
                        <section>
                            <h3>제1조 목적</h3>
                            <ul>
                                <li>본 약관은 심메타 서비스 운영기관(이하 ‘운영기관’이라 한다)에서 운영하는 GeoAI(건물 추출, 초해상화, 자동차 삭제/탐지, 변화탐지) 서비스를(이하 공공SaaS) 이용함에 있어 이용조건 및 절차, 운영기관과 이용자의 권리·의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.</li>
                            </ul>
                            <h3>제2조 용어의 정의</h3>
                            <ul>
                                <li>본 약관에서 사용하는 용어의 정의는 다음과 같습니다. 본 약관에서 정의하지 않은 것은 관련 법령 및 서비스별 안내에서 정하는 바에 따르며, 그 외에는 일반 관례에 따른다.</li>
                                <ol>
                                    <li>① 공유서비스 : 공유서비스란 인공지능 서비스에 활용할 수 있는 데이터, SW, 컴퓨팅 자원 등 우수한 정보자원을 공공 및 민간, 법인 및 개인이 원활하게 활용할 수 있도록 다양한 형식과 방식으로 제공하는 것을 말한다.</li>
                                    <li>② 제공기관 : 제공기관은 기관이 보유하고 있는 우수한 정보자원을 지정된 관리시스템을 통해 활용 가능한 공유서비스의 방식으로 개방, 제공하는 행정기관, 공공기관 및 민간 개인과 법인 등을 말한다.</li>
                                    <li>③ 활용기관 : 활용기관은 제공된 공유서비스를 직접 이용하거나 새로운 창작물의 일부로 재가공하여 배포하는 행정기관 등과 개인 및 법인을 말한다.</li>
                                    <li>④ 행정기관 등 : 행정기관 및 공공기관을 행정기관 등 이라 말한다.</li>
                                    <li>⑤ 회원 : 공공SaaS에 기관 및 기업, 개인 정보를 제공하여 제공기관 또는 활용기관으로 등록한 자로서 공공SaaS에서 제공하는 서비스를 이용할 수 있는 자.</li>
                                </ol>
                            </ul>
                            <h3>제3조 약관의 효력과 변경</h3>
                            <ul>
                                <li>1. 공공SaaS는 귀하가 본 약관 내용에 동의하는 경우, 공공SaaS의 서비스 제공 행위 및 귀하의 서비스 사용 행위에 본 약관이 우선적으로 적용됩니다.</li>
                                <li>2. 운영기관은 본 약관을 약관법 등 관련 법령에 위배되지 않는 범위 안에서 사전 고지 없이 변경할 수 있고, 변경된 약관은 공공SaaS 내에 공지와 동시에 그 효력이 발생됩니다. 회원이 변경된 약관에 동의하지 않는 경우, 회원은 본인의 회원등록을 취소(회원탈퇴)할 수 있으며 계속 사용하는 경우는 약관 변경에 대한 동의로 간주됩니다.</li>
                            </ul>
                            <h3>제4조 약관 외 준칙</h3>
                            <ul>
                                <li>본 약관에 명시되지 않은 사항은 전기통신기본법, 전기통신사업법, 정보통신에 관한 심의규정, 저작권법 및 기타 관련 법령의 규정에 의합니다.</li>
                            </ul>
                            <h3>제5조 이용 계약의 성립 등</h3>
                            <ul>
                                <li>1. 이용 계약은 법인 및 개인 신청자가 온라인으로 공공SaaS에서 제공하는 소정의 회원가입 신청 양식에서 요구하는 사항을 기록하여 가입을 완료하는 것으로 성립됩니다.</li>
                                <li>2. 행정기관 등은 법인 회원으로 가입한 이후에 공유서비스 제공기관으로 전환가입이 가능하며, 제공가입 후에는 공유서비스를 등록할 수 있는 자격이 부여됩니다.</li>
                                <li>3. 공공SaaS는 다음 각 호에 해당하는 이용계약에 대하여는 회원 가입을 취소할 수 있습니다.</li>
                                <ol>
                                    <li>① 다른 사람의 명의를 사용하여 신청하였을 때</li>
                                    <li>② 회원 가입 신청서의 내용을 허위로 기재하였을 경우</li>
                                    <li>③ 공공SaaS을 이용하여 법령과 본 약관이 금지하는 행위를 하는 경우</li>
                                    <li>④ 기타 운영기관에서 정한 제공기관 및 활용기관에 대한 공유정책 및 업무처리 기준에 위배된 경우.</li>
                                </ol>
                            </ul>
                            <h3>제6조 회원 정보 사용에 대한 동의</h3>
                            <ul>
                                <li>1. 회원의 개인정보는 개인정보법에 의해 보호됩니다.</li>
                                <li>2. 공공SaaS의 회원정보는 다음과 같이 사용, 관리, 보호됩니다.</li>
                                <ul>
                                    <li>① 개인정보의 사용 : 공공SaaS는 서비스 제공과 관련해서 수집된 회원의 신상정보를 본인의 승낙없이 제3자에게 누설, 배포하지 않습니다. 단, 전기통신기본법 등 법률의 규정에 의해 국가기관의 요구가 있 는 경우, 범죄에 대한 수사상의 목적이 있거나 방송통신심의위원회의 요청이 있는 경우 또는 기타 관계법령에서 정한 절차에 따른 요청이 있는 경우, 귀하가 공공SaaS에 제공한 개인정보를 스스로 공개한 경우에는 그러하지 않습니다.</li>
                                    <li>② 개인정보의 관리 : 귀하는 개인정보의 보호 및 관리를 위하여 서비스의 개인정보관리에서 수시로 귀하의 개인정보를 수정/삭제할 수 있습니다.</li>
                                    <li>③ 개인정보의 보호 : 귀하의 개인정보는 오직 귀하만이 열람/수정/삭제 할 수 있으며, 이는 전적으로 귀하의 ID와 비밀번호에 의해 관리되고 있습니다. 따라서 타인에게 본인의 ID와 비밀번호를 알려주어서 는 안되며, 작업 종료시에는 반드시 로그아웃 해 주시기 바랍니다.</li>
                                </ul>
                                <li>3. 회원이 본 약관에 따라 이용신청을 하는 것은 공공SaaS 회원가입 신청서에 기재된 회원정보를 ‘개인정보 취급방침’에 따라 수집, 이용하는 것에 동의하는 것으로 간주됩니다.</li>
                            </ul>

                            <h3>제7조 이용자의 정보 보안</h3>
                            <ul>
                                <li>1. 가입 신청자가 공공SaaS 회원가입 절차를 완료하는 순간부터 회원은 입력한 정보의 비밀을 유지할 책임이 있으며, 회원의 ID와 비밀번호를 사용하여 발생하는 모든 결과에 대한 책임은 회원 본인에게 있습니다.</li>
                                <li>2. 이용자는 회원의 ID나 비밀번호가 부정하게 사용 되었다는 사실을 발견한 경우에는 즉시 운영기관에 신고하여야 합니다. 신고를 하지 않음으로 인한 모든 책임 은 회원 본인에게 있습니다.</li>
                                <li>3. 회원은 공공SaaS 사용 종료 시마다 정확히 접속을 종료해야 하며, 정확히 종료하지 아니함으로써 제3자가 귀하에 관한 정보를 이용하게 되는 등의 결과로 인해 발생하는 손해 및 손실에 대하여 운영기관은 책임을 부담하지 아니합니다.</li>
                            </ul>
                            <h3>제8조 포털 이용 시간</h3>
                            <ul>
                                <li>1. 당 사이트는 제6조의 규정에 의한 이용신청고객에 대하여 서비스 이용을 승낙합니다.</li>
                                <li>2. 당 사이트는 아래사항에 해당하는 경우에 대해서 승낙하지 아니 합니다.
                                    <ul>
                                        <li>- 이용계약 신청서의 내용을 허위로 기재한 경우</li>
                                        <li>- 기타 규정한 제반 사항을 위반하며 신청하는 경우</li>
                                    </ul>
                                </li>
                            </ul>

                            <h3>제9조 서비스의 중지 및 정보의 저장과 사용</h3>
                            <ul>
                                <li>1. 공공SaaS에 보관되거나 전송된 메시지 및 기타 통신 메시지 등의 내용이 국가의 비상사태, 정전, 공공SaaS의 관리 범위 외의 서비스 설비 장애 및 기타 불가항력에 의하여 보관되지 못하였거나 삭제된 경우, 전송 되지 못한 경우 및 기타 통신 데이터의 손실이 있을 경우에 운영기관은 관련 책임을 부담하지 아니합니다.</li>
                                <li>2. 공공SaaS의 정상적인 서비스 제공이 불가하여 일시적으로 서비스를 중지하여야 할 경우에는 서비스 중지 1주일 전의 고지 후 서비스를 중지할 수 있으며, 이 기간 동안 귀하가 고지내용을 인지하지 못한 데 대하 여 운영기관은 책임을 부담하지 아니합니다. 부득이한 사정이 있을 경우 위 사전 고지기간은 감축되거나 생략될 수 있습니다. 또한 위 서비스 중지에 의하여 본 서비스에 보관되거나 전송된 메시지 및 기타 통신 메 시지 등의 내용이 보관되지 못하였거나 삭제된 경우, 전송되지 못한 경우 및 기타 통신 데이터의 손실이 있을 경우에 대하여도 운영기관은 책임을 부담하지 아니합니다.</li>
                                <li>3. 공공SaaS의 사정으로 서비스를 영구적으로 중단하여야 할 경우 제 2 항에 의거합니다. 다만, 이 경우 사전 고지기간은 1개월로 합니다.</li>
                                <li>4. 공공SaaS는 사전 고지 후 서비스를 일시적으로 수정, 변경 및 중단할 수 있으며, 이에 대하여 귀하 또는 제3자에게 어떠한 책임도 부담하지 아니합니다.</li>
                                <li>5. 공공SaaS는 이용자가 본 약관의 내용에 위배되는 행동을 한 경우, 임의적인 회원의 서비스 이용 중지시(회원등록 말소시) 회원에게 이 사실을 통지하고, 회원으로 하여금 소명할 수 있는 기회를 부여하고 소명기 간(30일 이상)을 추가 표기합니다.</li>
                            </ul>

                            <h3>제10조 서비스의 변경 및 해지</h3>
                            <ul>
                                <li>1. 공공SaaS는 회원이 서비스를 이용하여 기대하는 손익이나 서비스를 통하여 얻은 자료로 인한 손해에 관하여 책임을 지지 않으며, 회원이 본 서비스에 게재한 정보, 자료, 사실의 신뢰도, 정확성 등 내용에 관하여 는 책임을 지지 않습니다.</li>
                                <li>2. 공공SaaS는 서비스 이용과 관련하여 회원에게 발생한 손해 중 회원의 고의, 과실에 의한 손해에 대하여 책임을 부담하지 아니합니다.</li>
                            </ul>

                            <h3>제11조 정보 제공 및 홍보물 게재</h3>
                            <ul>
                                <li>1. 공공SaaS는 서비스를 운영함에 있어서 각종 정보를 서비스에 게재하는 방법 등으로 회원에게 제공할 수 있습니다.</li>
                                <li>2. 공공SaaS는 서비스에 적절하다고 판단되거나 활용 가능성 있는 홍보물을 게재할 수 있습니다.</li>
                            </ul>

                            <h3>제12조 게시물의 저작권</h3>
                            <ul>
                                <li>1. 제공기관이 게시한 게시물의 내용에 대한 권리는 기본적으로 제공기관 본인에게 있습니다.</li>
                                <li>2. 공공SaaS는 게시된 내용을 사전 통지 없이 편집, 이동할 수 있는 권리를 보유하며, 다음의 경우 사전 통지 없이 삭제할 수 있습니다.
                                    <ul>
                                        <li>① 본 서비스 약관에 위배되거나 상용 또는 불법, 음란, 저속하다고 판단되는 게시물을 게시한 경우</li>
                                        <li>② 다른 회원 또는 제 3자를 비방하거나 중상모략으로 명예를 손상시키는 내용인 경우</li>
                                        <li>③ 공공질서 및 미풍양속에 위반되는 내용인 경우</li>
                                        <li>④ 범죄적 행위에 결부된다고 인정되는 내용일 경우</li>
                                        <li>⑤ 제3자의 저작권 등 기타 권리를 침해하는 내용인 경우</li>
                                        <li>⑥ 기타 관계 법령에 위배되는 경우</li>
                                    </ul>
                                </li>
                                <li>3. 제공기관의 게시물이 타인의 저작권을 비롯한 기타 타인의 권리를 침해함으로써 발생하는 민, 형사상의 책임은 전적으로 제공기관이 부담하여야 합니다.</li>
                            </ul>

                            <h3>제13조 사용자의 행동 규범 및 서비스의 이용 제한</h3>
                            <ul>
                                <li>1. 회원이 제공하는 정보의 내용이 허위인 것으로 판명되거나, 그러하다고 의심할 만한 합리적인 사유가 발생할 경우 공공SaaS는 회원의 본 서비스 사용을 일부 또는 전부 중지할 수 있으며, 이로 인해 발생하는 불이익에 대해 책임을 부담하지 아니합니다.</li>
                                <li>2. 회원이 공공SaaS의 서비스를 통해 게시, 전송, 입수하였거나 전자메일 기타 다른 수단에 의하여 게시, 전송 또는 입수한 모든 형태의 정보에 대하여는 회원이 모든 책임을 부담하며 공공SaaS는 어떠한 책임도 부담하지 아니합니다.</li>
                                <li>3. 공공SaaS는 당 사이트가 제공한 서비스가 아닌 가입자 또는 기타 유관기관이 제공하는 서비스의 내용상의 정확성, 완전성 및 질에 대하여 보장하지 않습니다. 따라서 공공SaaS는 회원이 위 내용을 이용함으로 인하여 입게 된 모든 종류의 손실이나 손해에 대하여 책임을 부담하지 아니합니다.</li>
                                <li>4. 회원은 공공SaaS에서 다운로드 받은 데이터 내에 개인정보 또는 개인정보로 우려되는 정보가 포함된 것을 발견한 경우 즉시 공공SaaS 운영자에 신고하고 해당 데이터셋은 삭제를 하여야 합니다.</li>
                                <li>5. 회원은 공공SaaS로부터 제공받은 비식별 정보를 인공지능 서비스 개발 등의 목적으로 안전하게 이용하여야 하며, 이를 이용해서 개인을 재식별하기 위한 어떠한 행위도 하여서는 안됩니다.</li>
                                <li>6. 회원은 본 서비스를 통하여 다음과 같은 행동을 포함하여 서비스 운영정책에서 금지하는 행위를 하지 않는 것에 동의합니다.
                                    <ul>
                                        <li>① 타인의 아이디(ID)와 비밀번호를 도용하는 행위</li>
                                        <li>② 저속, 음란, 모욕적, 위협적이거나 타인의 프라이버시를 침해할 수 있는 내용을 전송, 게시, 게재, 전자메일 또는 기타의 방법으로 전송하는 행위</li>
                                        <li>③ 서비스를 통하여 전송된 내용의 출처를 위장하는 행위</li>
                                        <li>④ 법률, 계약에 의하여 이용할 수 없는 내용을 게시, 게재, 전자메일 또는 기타의 방법으로 전송하는 행위</li>
                                        <li>⑤ 타인의 특허, 상표, 영업비밀, 저작권, 기타 지식재산권을 침해하는 내용을 게시, 게재, 전자메일 또는 기타의 방법으로 전송하는 행위</li>
                                        <li>⑥ 운영기관의 승인을 받지 아니한 광고, 판촉물, 정크메일, 스팸, 행운의 편지, 피라미드 조직 기타 다른 형태의 권유를 게시, 게재, 전자메일 또는 기타의 방법으로 전송하는 행위</li>
                                        <li>⑦ 의도적으로 바이러스 프로그램 등 파괴적이거나 시스템에 손상을 줄 수 있는 아이템을 배포하는 행위</li>
                                        <li>⑧ 다른 사용자의 개인정보를 수집 또는 저장하는 행위</li>
                                        <li>⑨ 다른 사용자의 공공SaaS 서비스 이용을 방해하는 행위</li>
                                    </ul>
                                </li>
                                <li>7. 공공SaaS는 회원이 본 약관을 위배했다고 판단되면 서비스와 관련된 모든 정보를 회원의 동의 없이 삭제할 수 있습니다.</li>
                            </ul>

                            <h3>제14조 포털의 의무</h3>
                            <ul>
                                <li>㈜올포랜드의 맵프라임 서비스 이용약관 제14조를 따른다.</li>
                            </ul>

                            <h3>제15조 회원의 의무</h3>
                            <ul>
                                <li>㈜올포랜드의 맵프라임 서비스 이용약관 제15조를 따른다.</li>
                            </ul>

                            <h3>제16조 포털의 소유권</h3>
                            <ul>
                                <li>1. 공공SaaS가 제공하는 서비스, 그에 필요한 소프트웨어, 이미지, 마크, 로고, 디자인, 서비스명칭, 정보 및 상표 등과 관련된 지식재산권 및 기타 권리는 운영기관(및 공공SaaS 서비스 제공과 관련하여 운영기관과 계약을 체결한 기관)에 소유권이 있습니다.</li>
                                <li>2. 귀하는 공공SaaS에서 명시적으로 승인한 경우를 제외하고는 전항의 소정의 각 재산에 대한 전부 또는 일부의 수정, 대여, 대출, 판매, 배포, 제작, 양도, 재라이센스, 담보권 설정 행위, 상업적 이용 행위를 할 수 없 으며, 제3자로 하여금 이와 같은 행위를 하도록 허락할 수 없습니다.</li>
                            </ul>

                            <h3>제17조 양도 금지</h3>
                            <ul>
                                <li>회원이 서비스의 이용권한, 기타 이용계약 상 지위를 타인에게 양도, 증여할 수 없으며, 이를 담보로 제공할 수 없습니다. 단, 법인회원의 대표담당자 변경은 예외로 합니다.</li>
                            </ul>

                            <h3>제18조 손해 조항</h3>
                            <ul>
                                <li>공공SaaS는 무료로 제공되는 서비스와 관련하여 회원에게 어떠한 손해가 발생하더라도 공공SaaS가 고의로 행한 범죄행위를 제외하고 이에 대하여 책임을 부담하지 아니합니다.</li>
                            </ul>

                            <h3>제19조 면책 조항</h3>
                            <ul>
                                <li>1. 공공SaaS는 서비스에 표출된 어떠한 의견이나 정보에 대해 확신이나 대표할 의무가 없으며 회원이나 제3자에 의해 표출된 의견을 승인하거나 반대하거나 수정하지 않습니다. 공공SaaS는 어떠한 경우라도 회원 이 서비스에 담긴 정보에 의존해 얻은 이득이나 입은 손해에 대해 책임이 없습니다.</li>
                                <li>2. 공공SaaS는 회원 간 또는 회원과 제3자 간에 서비스를 매개로 하여 물품거래 혹은 금전적 거래 등과 관련하여 어떠한 책임도 부담하지 아니하고, 회원이 서비스의 이용과 관련하여 기대하는 이익에 관하여 책임 을 부담하지 않습니다.</li>
                            </ul>

                            <h3>제20조 보안요구사항의 반영 및 이행</h3>
                            <ul>
                                <li>1.운영기관은 국가기관 등 이용기관의 정보보호 정책 및 관련 법령에 따른 보안요구사항을 충분히 인지하고, 이를 본 계약에 따른 서비스 제공 과정에서 준수하여야 한다.</li>
                                <li>2.운영기관은 이용기관이 제시하는 보안요구사항을 기준으로 정보보호 및 개인정보 보호 대책을 수립하고, 기술적·관리적 보호조치를 서비스 운영에 반영하여야 한다.</li>
                                <li>3. 본 서비스는 「클라우드 컴퓨팅 발전 및 이용자 보호에 관한 법률」, 「정보통신망법」, 「개인정보 보호법」, 「전자정부법」 및 관계 법령, 지침, 국가기관의 보안 요구사항(CSAP 포함)에 따라 운영되어야 하며, 이에 따른 변경사항이 있을 경우, 갑의 요청에 따라 을은 서비스 수준협약(SLA) 및 보안 조치를 갱신 또는 보완하여야 한다.</li>
                                <li>4. 이용기관은은 정기적 또는 수시로 보안 점검을 요청할 수 있으며, 운영기관은 이에 성실히 협조하고 필요한 개선조치를 즉시 이행하여야 한다.</li>
                            </ul>

                            <h3>제21조 이용기관과 운영기관의 역할 및 책임</h3>
                            <ul>
                                <li>1. 이용기관은 클라우드 서비스를 이용함에 있어 보유 정보의 보호 수준, 중요도 및 활용 목적 등을 고려하여, 서비스 유형(IaaS, PaaS, SaaS) 및 보안요구사항을 명확히 정의하고 운영기관에게 제공한다.</li>
                                <li>2. 운영기관은 본 계약에 따라 제공하는 클라우드 서비스에 대해 다음의 책임을 진다.
                                    <ul>
                                        <li>①CSAP 인증 기준 및 관계 법령(「클라우드컴퓨팅법」, 「정보통신망법」, 「개인정보보호법」 등)에 따른 보안 수준 유지</li>
                                        <li>②클라우드 서비스 제공을 위한 물리적, 기술적, 관리적 보호조치의 수립 및 이행</li>
                                        <li>③서비스 장애, 보안사고 발생 시 즉시 이용기관에 통지하고, SLA에 따라 조치 수행</li>
                                        <li>④이용기관의 요청 시, 정보보호 현황에 대한 자료 제공 및 점검 수용</li>
                                        <li>⑤계약 종료 시, 이용기관의 데이터를 완전하게 반환하고, 영구 삭제</li>
                                    </ul>
                                </li>
                                <li>3. 이용기관과 운영기관은 서비스 운영과 정보보호에 관한 책임을 상호 협의할 수 있으며, **공동 책임 영역(예: 접근통제, 암호화 적용 범위 등)**은 별도 합의서 또는 기술 명세서에 의해 정의할 수 있다.</li>
                                <li>4. 보안사고 발생 시, 운영기관은 지체 없이 사고 사실을 이용기관에 보고하고, 원인 분석 및 재발 방지 대책을 포함한 사고 보고서를 제출하여야 한다. 해당 사고가 운영기관의 관리상 과실 또는 계약 위반에 기인한 경우, 운영기관은 그로 인해 발생한 손해를 배상하여야 한다.</li>
                            </ul>

                            <h3>제22조 이용자 데이터의 소유권, 저장 위치 및 보호</h3>
                            <ul>
                                <li>1. 이용기관의 모든 데이터(이하 “이용자 데이터”)에 대한 소유권은 전적으로 이용기관에 귀속되며, 운영기관은 이를 운영 목적 이외의 용도로 활용하거나 제3자에게 제공·이전할 수 없다.</li>
                                <li>2. 운영기관은 이용자 데이터를 포함한 모든 정보자산을 대한민국 내에 위치한 물리적 데이터센터 및 인프라(공공기관용 네이버클라우드 플랫폼 남부리전)에 저장·처리하여야 하며, 이용기관의 사전 서면 동의 없이 해외로의 이전, 반출, 접근을 허용해서는 안 된다.</li>
                                <li>3. 운영기관은 다음 각 호에 따른 방식으로 이용자 데이터를 안전하게 보호하여야 한다.
                                    <ul>
                                        <li>①저장 및 전송 구간의 암호화적용</li>
                                        <li>②접근 권한 최소화 및 이력관리</li>
                                        <li>③백업 및 재해복구 체계 구축, 주기적 점검 수행</li>
                                        <li>④데이터의 무단 복사, 변경, 유출 방지를 위한 기술적·관리적 보호조치 적용</li>
                                    </ul>
                                </li>
                                <li>4. 계약 종료, 서비스 해지 또는 이용기관의 요청 시, 운영기관은 이용자 데이터를 지정된 포맷과 매체로 반환하며, 이용기관의 검수 및 승인 후 완전하고 영구적으로 삭제하여야 한다. 삭제 시에는 이를 증명할 수 있는 삭제 확인서 또는 로그 자료를 이용기관에 제공하여야 한다.</li>
                                <li>5. 운영기관은 상기 조항의 위반으로 인해 발생한 정보유출, 분실 또는 손상 등 모든 사고에 대해 책임을 부담하며, 이용기관이 입은 손해를 배상하여야 한다.</li>
                            </ul>

                            <h3>제23조 제3자 및 하도급 업체의 관리 및 고지</h3>
                            <ul>
                                <li>1. 운영기관은 클라우드 서비스 제공과 관련하여 하도급 업체 또는 제3자((주)올포랜드, 네이버클라우드)를 활용할 경우, 해당 업체의 역할, 범위, 접속 권한, 데이터 처리 여부 등을 사전에 이용기관에게 서면으로 고지하여야 하며, 이용기관의 사전 동의 없이는 제3자에게 고객 데이터 또는 시스템 접근 권한을 부여할 수 없다.</li>
                                <li>2. 운영기관은 제3자 및 하도급 업체가 이용기관의 정보자산에 접근하거나 처리하는 경우, 다음 사항을 보장하여야 한다.
                                    <ul>
                                        <li>①이용기관의 보안요구사항 및 본 계약 조항의 동일 수준의 보안 의무를 해당 업체에도 적용</li>
                                        <li>②접근 권한 최소화 및 접근 기록 보관</li>
                                        <li>③보안사고 발생 시 공동 대응 체계 구축</li>
                                        <li>④하도급 업체의 보안 교육 및 정기 점검실시</li>
                                    </ul>
                                </li>
                                <li>3. 운영기관은 하도급 또는 제3자 활용으로 인해 발생한 정보유출, 시스템 장애, 보안사고 등으로 인해 이용기관에 손해가 발생한 경우, 해당 손해에 대해 전적인 책임을 진다.</li>
                                <li>4. 운영기관은 하도급 업체 명단, 역할, 보안조치 내역 등 관련 정보를 정기적으로 갱신하여 이용기관에 제공하여야 하며, 이용기관은 필요 시 해당 업체에 대한 보안 점검을 요청할 수 있다.</li>
                            </ul>

                            <h3>제24조 보안 인증 제품의 도입 의무</h3>
                            <ul>
                                <li>1. 운영기관은 본 계약에 따라 이용기관에게 제공되는 클라우드 서비스 또는 시스템 내 보안기능을 구현함에 있어, 관계 법령 및 보안지침에 따라 CC 인증, 보안기능확인서, 암호모듈검증필 제품 등 사전 인증이 완료된 보안제품만을 도입·사용하여야 한다.</li>
                                <li>2. 운영기관은 인증 유효기간, 제품 변경 여부 등을 고려하여 항상 유효한 인증 상태를 유지해야 하며, 제품 변경 시에는 사전에 이용기관의 승인을 받아야 한다.</li>
                                <li>3. 운영기관은 도입 보안제품의 인증서 사본 및 적용 내역을 계약 체결 시 또는 요청 시 이용기관에 제출하여야 한다.</li>
                                <li>4. 사전 인증이 요구되는 제품을 사용하지 않아 발생한 보안사고, 법적 제재 등 모든 책임은 운영기관에 있으며, 이용기관은 이에 대한 손해배상을 청구할 수 있다.</li>
                            </ul>

                            <h3>제25조 사고·장애 대응 및 유관기관 협조 의무</h3>
                            <ul>
                                <li>1. 운영기관은 서비스 제공 과정에서 사고(보안사고 포함) 또는 시스템 장애가 발생한 경우, 즉시 이용기관에 이를 통보하고, 사고 확산 방지 및 조속한 복구를 위하여 내부 대응조직 및 외부 전문가, 관련 기관과의 협조 체계를 즉시 가동하여야 한다.</li>
                                <li>2. 운영기관은 국가정보원, 한국인터넷진흥원(KISA), 과학기술정보통신부 등 유관기관의 보안 지침, 대응 요청 및 점검에 성실히 협조하여야 하며, 이용기관의 요청이 있는 경우 사고 조사, 원인 분석, 재발 방지 대책 수립 등에 공동으로 참여하여야 한다.</li>
                                <li>3. 운영기관은 사고 발생 시 다음의 절차에 따라 대응하여야 한다.
                                    <ul>
                                        <li>①사고 인지 후 1시간 이내에 이용기관 및 관련 기관에 1차 통보</li>
                                        <li>②24시간 이내에 사고조사 결과 및 임시 대응조치 보고서 제출</li>
                                        <li>③5영업일 이내에 최종 사고 보고서 및 재발방지 대책 보고서 제출</li>
                                    </ul>
                                </li>
                                <li>4. 이용기관은 필요한 경우 운영기관에 대해 사고 대응 체계, 보안 관제 체계, 백업 및 복구 체계 등에 대한 실사 또는 점검을 실시할 수 있으며, 운영기관은 이에 성실히 응하여야 한다.</li>
                                <li>5. 운영기관은 반복적 장애, 중대한 보안사고 또는 법령 위반이 발생한 경우, 이용기관의 요청에 따라 서비스 재구성 또는 계약 해지 절차에 협조하여야 한다.</li>
                            </ul>

                            <h3>제26조 보안관제, 점검 및 기술지원 협조 등</h3>
                            <ul>
                                <li>1. 운영기관은 클라우드 서비스 제공과 관련하여 클라우드 보안관제 기능을 자체적으로 수행하거나 외부 전문기관을 통해 운영하여야 하며, 정부 보안관제체계(국가정보원, KISA, 과기정통부 등)와의 연계를 위한 제반 환경(로그 수집, API 연계 등)을 갖추고, 이용기관의 요청이 있을 경우 협조하여야 한다.</li>
                                <li>2. 운영기관은 클라우드 컴퓨팅 서비스 망의 보안 운용 및 관리와 관련하여 다음의 활동에 성실히 협조하여야 한다.
                                    <ul>
                                        <li>①보안 취약점 발굴 및 개선</li>
                                        <li>②사이버 공격 위협에 대한 사전 예방 및 탐지·대응</li>
                                        <li>③보안 실태 평가 및 안전성·보안 대책 이행 여부 검토</li>
                                        <li>④기타 공공기관 및 정부 보안지침에 따른 점검 및 진단</li>
                                    </ul>
                                </li>
                                <li>3. 위 활동을 위해 이용기관 또는 유관기관(국가정보원, KISA 등)이 운영기관의 시설에 대해 현장 실사, 안전성 보안 측정, 보안 진단·점검등을 수행하고자 할 경우, 운영기관은 관련 정보, 문서, 출입 허가, 담당자 배치 등 필요한 협조를 제공하여야 하며, 방문 시 보안관리 계획을 수립하고, 관련 결과보고서를 요청 시 제출하여야 한다.</li>
                                <li>4. 또한 운영기관은 기술적 검증·점검을 위해 필요한 도구 및 환경(예: 로그 수집 도구, 모니터링 시스템, 시스템 구성도, 인터페이스 정보 등)을 제공하며, 이용기관의 요청이 있을 경우 정해진 형식과 주기로 데이터를 제공하여야 한다.</li>
                                <li>5. 이 외에도 이용기관이 요구하는 기관별 보안 요구사항(예: 망 분리, 사용자 인증 방식, 감사 로그 보관 기간 등)이 있는 경우, 운영기관은 해당 사항을 검토하여 계약 전 또는 운영 중 반영할 수 있도록 협의하여야 한다.</li>
                            </ul>

                            <h3>제27조 이용자 데이터의 제3자 제공 처리 절차</h3>
                            <ul>
                                <li>1. 클라우드서비스 운영자는 정부기관 또는 제3자의 요청으로 이용자 데이터를 제공하는 경우, 데이터 소유자의 동의를 원칙으로 하며, 개인정보가 포함된 경우에는 **「개인정보 보호법」 등 관련 법령에서 정한 절차에 따라 제공하여야 한다.</li>
                                <li>2. 데이터 제공 시에는 사전 승인, 제공 내역 기록, 이용기관 통보 등의 절차를 수립·운영하여야 하며, 외부 제공 이력은 문서로 관리하여야 한다.</li>
                            </ul>

                            <h3>제28조 관할 법원</h3>
                            <ul>
                                <li>본 서비스 이용과 관련하여 발생한 분쟁에 대해 소송이 제기될 경우 서울중앙지방법원을 전속적 관할 법원으로 합니다.</li>
                                <li>① (시행일) 본 약관은 2025년 1월 1일부터 시행됩니다.</li>
                            </ul>

                            <h3>제29조 기타</h3>
                            <ul>
                                <li>이 이용 약관에 기재되지 않은 사항은 ㈜올포랜드의 맵프라임 서비스 이용약관을 따른다.</li>
                            </ul>
                            <h3>[별지 제1호] ㈜올포랜드의 맵프라임클라우드 서비스 이용약관 중 제14조, 제15조</h3>
                            <h4>제14조 포털의 의무</h4>
                            <ul>
                                <li>1. 공공SaaS는 법령과 본 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 지속적, 안정적으로 서비스를 제공하기 위해 노력할 의무가 있습니다.</li>
                                <li>2. 공공SaaS는 회원의 개인 신상 정보를 본인의 승낙 없이 타인에게 누설, 배포하지 않습니다. 다만, 전기통신관련법령 등 관계법령에 의하여 관계 국가기관 등의 요구가 있는 경우에는 그러하지 아니합니다.</li>
                                <li>3. 공공SaaS는 이용자가 안전하게 당 사이트 서비스를 이용할 수 있도록 이용자의 개인정보(신용정보 포함) 보호를 위한 보안시스템을 갖추어야 합니다.</li>
                                <li>4. 공공SaaS는 이용자의 귀책사유로 인한 서비스 이용 장애에 대해 책임을 지지 않습니다.</li>
                            </ul>

                            <h4>제15조 회원의 의무</h4>
                            <ul>
                                <li>1. 회원 가입시에 요구되는 정보는 정확하게 기입하여야 합니다. 또한 이미 제공된 회원 정보가 정확한 정보가 되도록 유지, 갱신하여야 하며, 회원은 자신의 ID 및 비밀번호를 제3자에게 이용하게 해서는 안됩니다.</li>
                                <li>2. 회원은 공공SaaS의 사전 승낙 없이 서비스를 이용하여 어떠한 영리행위도 할 수 없습니다.</li>
                                <li>3. 회원은 일부 개인정보를 포함한 서비스 중 사전 승낙이 필요함을 별도로 명시한 경우 사전 승낙 없이 공공SaaS의 서비스를 이용하여 얻은 정보를 복사, 복제, 변경, 번역, 출판·방송 기타의 방법으로 사용하거나 이 를 타인에게 제공할 수 없습니다.</li>
                                <li>4. 회원은 공공SaaS의 서비스 이용과 관련하여 다음 각 호의 행위를 하여서는 안됩니다.
                                    <ul>
                                        <li>① 다른 회원의 ID를 부정 사용하는 행위</li>
                                        <li>② 범죄행위를 목적으로 하거나 기타 범죄행위와 관련된 행위</li>
                                        <li>③ 선량한 풍속, 기타 사회질서를 해하는 행위</li>
                                        <li>④ 타인의 명예를 훼손하거나 모욕하는 행위</li>
                                        <li>⑤ 타인의 지식재산권 등의 권리를 침해하는 행위</li>
                                        <li>⑥ 해킹행위 또는 컴퓨터 바이러스 유포행위</li>
                                        <li>⑦ 타인의 의사에 반하여 광고성 정보 등 일정한 내용을 지속적으로 전송하는 행위</li>
                                        <li>⑧ 서비스의 안전적인 운영에 지장을 주거나 줄 우려가 있는 일체의 행위</li>
                                        <li>⑨ 공공SaaS에 게시된 정보의 변경</li>
                                    </ul>
                                </li>
                            </ul>
                        </section>
                        <section>
                            
                        </section>
                        <section>
                            
                        </section>
                        <section>
                            
                        </section>
                        <section>
                            
                        </section>
                        <section>
                            
                        </section>
                        <section>
                            
                        </section>
                        <section>
                            
                        </section>
                        <section>
                            
                        </section>
                        <section>
                            
                        </section>
                        <section>
                            
                        </section>
                        <section>
                            
                        </section>
                        <section>
                            
                        </section>
                        <section>
                            
                        </section>
                        <section>
                            
                        </section>
                        <section>
                            
                        </section>
                        <section>
                            
                        </section>
                        <section>
                            
                        </section>
                        <section>
                            
                        </section>
                        <section>
                            
                        </section>
                        <section>
                            
                        </section>
                        <section>
                            
                        </section>
                        <section>
                            
                        </section>
                        <section>
                            
                        </section>
                        <section>
                            
                        </section>
                        <section>
                            
                        </section>
                        <section>
                            
                        </section>
                        <section>
                            
                        </section>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Term;